// Contenu complet extrait des pages statiques du site

export const getPageDefaultContent = (slug) => {
  const content = {
    'home': {
      page_title: 'Page d\'accueil',
      meta_description: 'SFOALC - Société Française des Ophtalmologistes Adaptateurs de Lentilles de Contact',
      blocks: [
        {
          id: 'home_hero',
          type: 'hero',
          content: {
            title: 'Société Française des Ophtalmologistes Adaptateurs de Lentilles de Contact',
            subtitle: 'L\'adaptation des lentilles de contact est un acte médical. Rejoignez la SFOALC pour accéder à la formation continue, l\'annuaire des praticiens et un réseau d\'excellence.',
            buttonText: 'Rejoignez-nous',
            buttonLink: '/adhesion',
            backgroundImage: '',
            textAlign: 'center'
          }
        },
        {
          id: 'home_stats',
          type: 'columns',
          content: {
            columnsCount: 4,
            columns: [
              { content: '<div class="text-center"><div class="text-5xl font-bold text-cyan-600 mb-2">13</div><div class="text-gray-600">Régions représentées</div></div>' },
              { content: '<div class="text-center"><div class="text-5xl font-bold text-cyan-600 mb-2">20+</div><div class="text-gray-600">Ans d\'existence</div></div>' },
              { content: '<div class="text-center"><div class="text-5xl font-bold text-cyan-600 mb-2">500+</div><div class="text-gray-600">Membres actifs</div></div>' },
              { content: '<div class="text-center"><div class="text-5xl font-bold text-cyan-600 mb-2">100+</div><div class="text-gray-600">Formations disponibles</div></div>' }
            ]
          }
        },
        {
          id: 'home_services_title',
          type: 'heading',
          content: {
            text: 'Nos Services',
            level: 'h2',
            textAlign: 'center'
          }
        },
        {
          id: 'home_services_subtitle',
          type: 'text',
          content: {
            content: '<p class="text-center text-lg text-gray-600">Découvrez tout ce que la SFOALC peut vous apporter dans votre pratique quotidienne</p>',
            fontSize: 'lg',
            textAlign: 'center'
          }
        },
        {
          id: 'home_services',
          type: 'columns',
          content: {
            columnsCount: 2,
            columns: [
              { content: '<div class="p-6 bg-white rounded-xl border-2 border-gray-100 hover:border-cyan-400 transition-all"><h3 class="text-xl font-bold text-gray-900 mb-3">👥 Annuaire des Praticiens</h3><p class="text-gray-600">Trouvez un ophtalmologiste adaptateur de lentilles près de chez vous</p></div>' },
              { content: '<div class="p-6 bg-white rounded-xl border-2 border-gray-100 hover:border-cyan-400 transition-all"><h3 class="text-xl font-bold text-gray-900 mb-3">📚 Formations Continue</h3><p class="text-gray-600">Accédez à des formations, replays et cours réservés aux membres</p></div>' },
              { content: '<div class="p-6 bg-white rounded-xl border-2 border-gray-100 hover:border-cyan-400 transition-all"><h3 class="text-xl font-bold text-gray-900 mb-3">🎓 Publications Scientifiques</h3><p class="text-gray-600">Consultez les dernières publications et recherches en contactologie</p></div>' },
              { content: '<div class="p-6 bg-white rounded-xl border-2 border-gray-100 hover:border-cyan-400 transition-all"><h3 class="text-xl font-bold text-gray-900 mb-3">🏆 Adhésion en Ligne</h3><p class="text-gray-600">Rejoignez la SFOALC et bénéficiez de tous les avantages membres</p></div>' }
            ]
          }
        }
      ]
    },

    'about': {
      page_title: 'À propos',
      meta_description: 'Découvrez la SFOALC, association d\'ophtalmologistes adaptateurs de lentilles de contact',
      blocks: [
        {
          id: 'about_hero',
          type: 'hero',
          content: {
            title: 'Qui sommes-nous ?',
            subtitle: 'La SFOALC est une association créée dans les années 2000 qui regroupe l\'ensemble des ophtalmologistes qui pratiquent la contactologie médicale.',
            buttonText: '',
            buttonLink: '',
            backgroundImage: '',
            textAlign: 'center'
          }
        },
        {
          id: 'about_mission_title',
          type: 'heading',
          content: {
            text: 'L\'adaptation des lentilles de contact est un acte médical',
            level: 'h2',
            textAlign: 'left'
          }
        },
        {
          id: 'about_mission_text',
          type: 'text',
          content: {
            content: `<p class="mb-4">Nous sommes profondément convaincus que <strong>l'adaptation des lentilles de contact est un acte médical</strong> complexe, nécessitant des connaissances approfondies en anatomie, physiologie et pathologie oculaire, ainsi qu'une formation spécialisée continue.</p>
            <p class="mb-4">Notre société réunit des professionnels dédiés à promouvoir <strong>l'excellence en contactologie</strong> et à garantir la sécurité et le bien-être de chaque patient porteur de lentilles.</p>
            <p>Nous nous engageons à maintenir les plus hauts standards de qualité dans notre pratique et à partager nos connaissances au sein de notre communauté.</p>`,
            fontSize: 'base',
            textAlign: 'left'
          }
        },
        {
          id: 'about_stats',
          type: 'columns',
          content: {
            columnsCount: 4,
            columns: [
              { content: '<div class="text-center p-6 bg-cyan-50 rounded-xl"><div class="text-4xl font-bold text-cyan-600 mb-2">13</div><div class="text-gray-700 font-medium">Régions représentées</div></div>' },
              { content: '<div class="text-center p-6 bg-blue-50 rounded-xl"><div class="text-4xl font-bold text-blue-600 mb-2">20+</div><div class="text-gray-700 font-medium">Ans d\'existence</div></div>' },
              { content: '<div class="text-center p-6 bg-purple-50 rounded-xl"><div class="text-4xl font-bold text-purple-600 mb-2">500+</div><div class="text-gray-700 font-medium">Membres actifs</div></div>' },
              { content: '<div class="text-center p-6 bg-green-50 rounded-xl"><div class="text-4xl font-bold text-green-600 mb-2">100+</div><div class="text-gray-700 font-medium">Formations disponibles</div></div>' }
            ]
          }
        },
        {
          id: 'about_values_title',
          type: 'heading',
          content: {
            text: 'Nos Valeurs',
            level: 'h2',
            textAlign: 'center'
          }
        },
        {
          id: 'about_values',
          type: 'columns',
          content: {
            columnsCount: 3,
            columns: [
              { content: '<div class="p-6 text-center"><div class="text-4xl mb-4">🎯</div><h3 class="text-xl font-bold mb-3">Notre Mission</h3><p class="text-gray-600">Promouvoir l\'excellence en contactologie et soutenir la formation continue des professionnels de santé visuelle.</p></div>' },
              { content: '<div class="p-6 text-center"><div class="text-4xl mb-4">🏆</div><h3 class="text-xl font-bold mb-3">Excellence</h3><p class="text-gray-600">Garantir les plus hauts standards de qualité dans l\'adaptation des lentilles de contact et les soins aux patients.</p></div>' },
              { content: '<div class="p-6 text-center"><div class="text-4xl mb-4">👥</div><h3 class="text-xl font-bold mb-3">Communauté</h3><p class="text-gray-600">Rassembler les ophtalmologistes adaptateurs de lentilles de contact pour partager les connaissances et les bonnes pratiques.</p></div>' }
            ]
          }
        }
      ]
    },

    'contact': {
      page_title: 'Contact',
      meta_description: 'Contactez la SFOALC',
      blocks: [
        {
          id: 'contact_hero',
          type: 'hero',
          content: {
            title: 'Contactez-nous',
            subtitle: 'Vous avez une question ? N\'hésitez pas à nous contacter, nous vous répondrons dans les meilleurs délais.',
            buttonText: '',
            buttonLink: '',
            backgroundImage: '',
            textAlign: 'center'
          }
        },
        {
          id: 'contact_info',
          type: 'columns',
          content: {
            columnsCount: 3,
            columns: [
              { content: '<div class="p-6 text-center"><div class="text-4xl mb-3">📧</div><h3 class="font-bold mb-2">Email</h3><p class="text-gray-600">contact@sfoalc.fr</p></div>' },
              { content: '<div class="p-6 text-center"><div class="text-4xl mb-3">📞</div><h3 class="font-bold mb-2">Téléphone</h3><p class="text-gray-600">01 XX XX XX XX</p></div>' },
              { content: '<div class="p-6 text-center"><div class="text-4xl mb-3">📍</div><h3 class="font-bold mb-2">Adresse</h3><p class="text-gray-600">Paris, France</p></div>' }
            ]
          }
        },
        {
          id: 'contact_form_note',
          type: 'text',
          content: {
            content: '<div class="p-6 bg-blue-50 rounded-xl border border-blue-200"><p class="text-blue-800">💡 <strong>Note :</strong> Pour toute demande spécifique concernant votre adhésion ou votre compte membre, veuillez utiliser l\'espace membre après connexion.</p></div>',
            fontSize: 'base',
            textAlign: 'left'
          }
        }
      ]
    },

    'partners': {
      page_title: 'Partenaires',
      meta_description: 'Découvrez nos partenaires',
      blocks: [
        {
          id: 'partners_hero',
          type: 'hero',
          content: {
            title: 'Nos Partenaires',
            subtitle: 'La SFOALC collabore avec des partenaires de confiance pour offrir les meilleurs services à ses membres.',
            buttonText: '',
            buttonLink: '',
            backgroundImage: '',
            textAlign: 'center'
          }
        },
        {
          id: 'partners_intro',
          type: 'text',
          content: {
            content: '<p class="text-lg text-gray-700 mb-6">Nous travaillons en étroite collaboration avec des laboratoires, des fabricants et des institutions pour promouvoir l\'excellence en contactologie.</p><p class="text-gray-600">Si vous souhaitez devenir partenaire de la SFOALC, n\'hésitez pas à nous contacter.</p>',
            fontSize: 'base',
            textAlign: 'center'
          }
        },
        {
          id: 'partners_note',
          type: 'text',
          content: {
            content: '<div class="p-6 bg-cyan-50 rounded-xl border border-cyan-200"><p class="text-cyan-800">🤝 Nous recherchons activement de nouveaux partenaires pour enrichir notre écosystème et offrir toujours plus de valeur à nos membres.</p></div>',
            fontSize: 'base',
            textAlign: 'left'
          }
        }
      ]
    },

    'faq': {
      page_title: 'FAQ',
      meta_description: 'Questions fréquentes sur la SFOALC',
      blocks: [
        {
          id: 'faq_hero',
          type: 'heading',
          content: {
            text: 'Questions Fréquentes',
            level: 'h1',
            textAlign: 'center'
          }
        },
        {
          id: 'faq_intro',
          type: 'text',
          content: {
            content: '<p class="text-center text-lg text-gray-600 mb-12">Retrouvez les réponses aux questions les plus fréquemment posées sur la SFOALC, l\'adhésion et nos services.</p>',
            fontSize: 'lg',
            textAlign: 'center'
          }
        },
        {
          id: 'faq_q1',
          type: 'text',
          content: {
            content: '<div class="mb-6"><h3 class="text-xl font-bold mb-2">❓ Comment adhérer à la SFOALC ?</h3><p class="text-gray-700">Vous pouvez adhérer en ligne via notre formulaire d\'adhésion. L\'adhésion est réservée aux ophtalmologistes.</p></div>',
            fontSize: 'base',
            textAlign: 'left'
          }
        },
        {
          id: 'faq_q2',
          type: 'text',
          content: {
            content: '<div class="mb-6"><h3 class="text-xl font-bold mb-2">❓ Quels sont les avantages de l\'adhésion ?</h3><p class="text-gray-700">Accès aux formations continues, à l\'annuaire des praticiens, aux publications scientifiques et à un réseau d\'excellence.</p></div>',
            fontSize: 'base',
            textAlign: 'left'
          }
        },
        {
          id: 'faq_q3',
          type: 'text',
          content: {
            content: '<div class="mb-6"><h3 class="text-xl font-bold mb-2">❓ Quel est le coût de l\'adhésion ?</h3><p class="text-gray-700">Contactez-nous pour connaître les tarifs d\'adhésion selon votre profil.</p></div>',
            fontSize: 'base',
            textAlign: 'left'
          }
        }
      ]
    },

    'legal': {
      page_title: 'Mentions légales',
      meta_description: 'Mentions légales du site SFOALC',
      blocks: [
        {
          id: 'legal_title',
          type: 'heading',
          content: {
            text: 'Mentions Légales',
            level: 'h1',
            textAlign: 'center'
          }
        },
        {
          id: 'legal_content',
          type: 'text',
          content: {
            content: `<div class="space-y-6">
              <div><h2 class="text-2xl font-bold mb-3">Éditeur du site</h2><p><strong>SFOALC</strong><br>Société Française des Ophtalmologistes Adaptateurs de Lentilles de Contact<br>Association loi 1901</p></div>
              <div><h2 class="text-2xl font-bold mb-3">Hébergement</h2><p>Ce site est hébergé par un prestataire professionnel.</p></div>
              <div><h2 class="text-2xl font-bold mb-3">Propriété intellectuelle</h2><p>L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés.</p></div>
            </div>`,
            fontSize: 'base',
            textAlign: 'left'
          }
        }
      ]
    },

    'privacy': {
      page_title: 'Politique de confidentialité',
      meta_description: 'Politique de confidentialité SFOALC',
      blocks: [
        {
          id: 'privacy_title',
          type: 'heading',
          content: {
            text: 'Politique de Confidentialité',
            level: 'h1',
            textAlign: 'center'
          }
        },
        {
          id: 'privacy_intro',
          type: 'text',
          content: {
            content: '<p class="text-center text-lg text-gray-700 mb-8">La protection de vos données personnelles est une priorité pour la SFOALC.</p>',
            fontSize: 'lg',
            textAlign: 'center'
          }
        },
        {
          id: 'privacy_content',
          type: 'text',
          content: {
            content: `<div class="space-y-6">
              <div><h2 class="text-2xl font-bold mb-3">Collecte des données</h2><p class="text-gray-700">Nous collectons uniquement les données nécessaires au fonctionnement de nos services et à la gestion de votre adhésion.</p></div>
              <div><h2 class="text-2xl font-bold mb-3">Utilisation des données</h2><p class="text-gray-700">Vos données sont utilisées exclusivement dans le cadre de votre adhésion et ne sont jamais vendues à des tiers.</p></div>
              <div><h2 class="text-2xl font-bold mb-3">Vos droits</h2><p class="text-gray-700">Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles.</p></div>
            </div>`,
            fontSize: 'base',
            textAlign: 'left'
          }
        }
      ]
    }
  };

  return content[slug] || null;
};

export default getPageDefaultContent;
